export default "__VITE_ASSET__0f4097f8__"